import React, { FC } from "react";
import { Element } from "../../models/elementModel";
import ButtonElement from "./renderElementComponents/ButtonElement";
import CollapsElement from "./renderElementComponents/collapsElement/CollapsMain";
import DropdownElement from "./renderElementComponents/DropdownElement";
import HeadingElement from "./renderElementComponents/HeadingElement";
import ImageElement from "./renderElementComponents/ImageElement";
import RenderInputElement from "./renderElementComponents/inputElement/utils/renderInputElement";
import InputFileElemnt from "./renderElementComponents/InputFileElement";
import LabelElement from "./renderElementComponents/LabelElement";
import NavigationElement from "./renderElementComponents/navigationElement/NavigationElement";
import RadioBtnElement from "./renderElementComponents/RadioButtonElement";
import TableElement from "./renderElementComponents/tabelElement/tableElement";
import TabElement from "./renderElementComponents/tabElement/tabElement";
import TextAreaElement from "./renderElementComponents/TextAreaElement";
import TypographyElement from "./renderElementComponents/TypographyElement";
import VideoEmbedElement from "./renderElementComponents/VideoEmbedElement";
import CarouselElement from "./renderElementComponents/carouselElement/CarouselElement";

export interface CommonPropertyProps {
  index: string;
  element: Element;
  isPreview?: boolean;
}

const CommonPropertyElement: FC<CommonPropertyProps> = ({ index, element, isPreview = false }) => {

  //custome css lbl - start
  const lblStyleList = element.properties.lblCssStyles;

  const lblStyleObj: { [key: string]: any } = {};

  if (lblStyleList !== undefined) {
    for (let index = 0; index < lblStyleList.length; index++) {
      lblStyleObj[lblStyleList[index].retrivedStyle] = lblStyleList[index].value;
    }
  }
  //custome css lbl - end


  const getElementType = () => {
    switch (element.type) {
      case "input":
        return <RenderInputElement index={index} element={element} isPreview={isPreview} />;
      case "txtarea":
        return <TextAreaElement index={index} element={element} isPreview={isPreview} />;
      case "dropdown":
        return <DropdownElement index={index} element={element} isPreview={isPreview} />;
      case "btn":
        return <ButtonElement index={index} element={element} isPreview={isPreview} />;
      case "heading":
        return <HeadingElement index={index} element={element} isPreview={isPreview} />;
      case "lbl":
        return <LabelElement index={index} element={element} isPreview={isPreview} />;
      case "rdioBtn":
      case "chkBox":
        return <RadioBtnElement index={index} element={element} isPreview={isPreview} />;
      case "img":
        return <ImageElement index={index} element={element} isPreview={isPreview} />;
      case "tab":
        return <TabElement index={index} element={element} isPreview={isPreview} />;
      case "navbar":
        return <NavigationElement index={index} element={element} isPreview={isPreview} />;
      case "table":
        return <TableElement index={index} element={element} isPreview={isPreview} />
      case "collaps":
        return <CollapsElement index={index} element={element} isPreview={isPreview} />
      case "video":
      case "map":
        return <VideoEmbedElement index={index} element={element} isPreview={isPreview} />
      case "file":
        return <InputFileElemnt index={index} element={element} isPreview={isPreview} />
      case "typography":
        return <TypographyElement index={index} element={element} isPreview={isPreview} />
      case "carousel":
        return <CarouselElement index={index} element={element} isPreview={isPreview} />
      default:
        return null;
    }
  };
  return (
    <div
      key={index}
      style={{
        display: element.properties.flex,
        justifyContent: element.properties.justifyContent,
      }}
    >
      {(element.properties.labelPosition === "T" ||
        element.properties.labelPosition === "B") && (
        <div style={{ textAlign: element.properties.labelAlign }}>
          {element.properties.labelPosition === "T" && (
            <label style={{ ...lblStyleObj }} htmlFor={element.properties.id}>
              {element.properties.labelText}
            </label>
          )}
          {getElementType()}
          {element.properties.labelPosition === "B" && (
            <label style={{ ...lblStyleObj }} htmlFor={element.properties.id}>
              {element.properties.labelText}
            </label>
          )}
        </div>
      )}
      {(element.properties.labelPosition === "L" ||
        element.properties.labelPosition === "R") && (
        <div className="row g-3 align-items-center">
          {element.properties.labelPosition === "L" && (
            <div className="col-auto">
              <label style={{ ...lblStyleObj }} htmlFor={element.properties.id}>
                {element.properties.labelText}
              </label>
            </div>
          )}
          <div className="col-auto">{getElementType()}</div>
          {element.properties.labelPosition === "R" && (
            <div className="col-auto">
              <label style={{ ...lblStyleObj }} htmlFor={element.properties.id}>
                {element.properties.labelText}
              </label>
            </div>
          )}
        </div>
      )}
      {(element.properties.labelPosition === "" ||
        element.properties.labelPosition == undefined) &&
        getElementType()}
    </div>
  );
};

export default CommonPropertyElement;
